import { useState } from 'react';

export const useForm = (initialForm = {}) => {

    const [form, setForm] = useState(initialForm);

    const onInputChange = ({ target }) => {
        const { name, value, type, checked } = target
        const newValue = (type === 'checkbox' ? checked : value)

        setForm({
            ...form,
            [name]: newValue
        })
    }

    const onResetForm = () => {
        setForm(initialForm);
    }

    return {
        ...form,
        form,
        onInputChange,
        onResetForm,
    }
}